
import { Component, Vue, } from 'vue-property-decorator';
import { Store, } from '~/apps/move-in/store';
import FeedbackBox from '~/components/feedback-box/feedback-box.vue';
import HeaderText from '~/components/header-text/header-text.vue';
import LandingLink from '~/components/landing-link/landing-link.vue';
import Checklist from '~/components/self-serve/checklist/checklist.vue';
import LandingSection from '~/components/self-serve/landing-section/landing-section.vue';
import RadioGroup from '~/components/self-serve/radio-group/radio-group.vue';
import { CHECKLIST_ITEMS, } from '~/utils/self-serve-checklist-items';

const ChecklistItems = [
	CHECKLIST_ITEMS.newAddress,
	CHECKLIST_ITEMS.moveInDate,
];

@Component({
	components: {
		HeaderText,
		LandingLink,
		FeedbackBox,
		RadioGroup,
		LandingSection,
		Checklist,
	},
})
export default class MoveInLandingPage extends Vue {

	isNewCustomer = true;

	mounted() {

		Store.commit.setStep(null);
		// this fix added for the SSR-1522:Remember lastly selected radio button on the browser-back button
		if (Store.state.userDetails.isNewCustomer === true) {
			Store.commit.updateIsNewCustomer(false);
		} else {
			Store.commit.reset();
			Store.commit.updateIsNewCustomer(true);
		}
	}

	findPostCode = Store.getters.getGlobalConfigValue('FindPostCode') as string;
	contactUs = Store.getters.getGlobalConfigValue('ContactUsLocation') as string;
	checklistItems = ChecklistItems;
}
